import React, { Component } from "react";
import "./style.css";
import {
  Select,
  Input,
  Modal,
  Icon,
  Tooltip,
  Form,
  Table,
  Pagination,
  Button,
  Spin,
  Row,
  Col,
  notification,
  message,
  Checkbox, Popover
} from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import * as actions from "../../actions/index";
import { compose } from "recompose";
import { bindActionCreators } from "redux";
import ReactToPrint from "react-to-print";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SearchAlumni from "../Inc/SearchAlumni";
import moment from "moment";
import GroupFields from "./GroupFields";
import CommunityTypes from "./CommunityTypes";
import { map } from "lodash";

import { BooleanFilters, nationalAwards } from '../../auth';

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const FormItem = Form.Item;
const Option = Select.Option;
const Save = Input.Search;
// let uuid = 0;

const getItems = count =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k}`,
    content: `item ${k}`
  }));

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex - 1, 1);
  result.splice(endIndex - 1, 0, removed);
  return result;
};

const INTERNAL_ONLY_COLUMNS = ["personguid", "councilnumber"];
// Shown in the results table when filtered on, but not offered in the "Change Columns" dropdown.
const FILTER_ONLY_COLUMNS = ["donotcontact", "alumniprivacy", "affinitygroupid", "scoutingaffiliationid"];
const ID_FILTER_COLUMNS = { affinitygroup: "AffinityGroupID", scoutingaffiliation: "ScoutingAffiliationID" };
const ID_FILTER_OPERATORS = ["eq", "equals", "inlist", "doesnotmatch", "ne", "bv", "nbv"];
const REPORT_COLUMN_ALIASES = {
  commorgcatshort: "communityorganizationcategorycode",
  commorgcatlong: "communityorganizationcategoryname",
  commorgtypelong: "communityorganizationtypename",
};
const REVERSE_REPORT_COLUMN_ALIASES = Object.entries(REPORT_COLUMN_ALIASES).reduce(
  (acc, [apiNameLower, internalValue]) => {
    acc[internalValue] = apiNameLower;
    return acc;
  },
  {}
);

const normalizeAwardName = str => (str || "").toLowerCase().replace(/[^a-z0-9]/g, "");

// Selecting an "Is_<Award>" boolean column should also show the NationalAward column, but only when that award exists in the nationalAwards list.
const hasNationalAwardColumn = columns =>
  (columns || []).some(col => {
    const lower = (col || "").toLowerCase();
    if (!lower.startsWith("is_")) return false;
    const award = normalizeAwardName(lower.slice(3));
    return nationalAwards.some(a => normalizeAwardName(a).includes(award));
  });

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: "0",
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  // background: isDragging ? "" : "",
  background: "",

  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = isDraggingOver => ({
  // background: isDraggingOver ? "" : ""
  background: ""
});

let uid = 0;
let groupids = [];
let result = {};
let selectedPreferenceName = "";
let SelectedListType = "";
let getTotalRecordCount;

// const operatorMap = {
//   EQ: "",
//   NotEQ: "Not",
//   CONTAINS: "Contains",
//   DoesNotContain: "DoesNotContain",
//   StartsWith: "StartsWith",
//   StartsWithList: "StartsWith",
//   DoesNotStartWith: "DoesNotStartWith",
//   DoesNotStartWithList: "DoesNotStartWith",
//   INLIST: "INLIST",
//   CONTAINS_LIST: "ContainsList",
//   DoesNotContain_LIST: "DoesNotContainList"
// };

class DynamicFieldSet extends React.Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.onIdle = this.onIdle.bind(this);
    this.state = {
      ...props,
      uuid: 0,
      query: "",
      items: getItems(10),
      queryfilterlist: [],
      listtype: 1,
      currentpage: 1,
      formula: "",
      columns: [],
      expressions: [],
      preference: { Formula: "", Expressions: [] },
      columnjson: [],
      columnId: [],
      keys: [1, 2, 3],
      fieldsItems: {},
      fieldsId: [],
      fieldsgroup: {},
      updateFields: [],
      columIdByChield: [],
      showSave: false,
      results: [],
      savedpreference: "",
      savedpreferenceType: "",
      savedpreferenceColumns: [],
      ViewMode: "",
      totalPage: "",
      perPageSize: 10,
      getCouncilNumber: undefined,
      isEaglesOnly: false,
      isCouncilNumberSelected: false,
      searched: false,
      fileName: '',
      columnDragOrder: null,
      columnKeyValues: {}
    };

    this.savelist = this.savelist.bind(this);
    this.listTypeSelected = this.listTypeSelected.bind(this);
    // this.listTypeSelectedColumn = this.listTypeSelectedColumn.bind(this)
    this.onColumnDragEnd = this.onColumnDragEnd.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // this.loadpreference = this.loadpreference.bind(this)

    console.log(this.onIdle);
  }

   handleFileNameChange = e => {
    this.setState({
      fileName: e.target.value
    })
  }

  getColumnKeyOrder = (ColumnKeys) => {
    const { columnDragOrder } = this.state;

    if (
      Array.isArray(columnDragOrder) &&
      columnDragOrder.length === ColumnKeys.length &&
      columnDragOrder.every(key => ColumnKeys.includes(key))
    ) {
      return columnDragOrder;
    }

    return ColumnKeys;
  };

  onColumnDragEnd(result) {
    // TEMPORARY diagnostic logging (AAG-1400) - remove once the drag issue is confirmed fixed.
    console.log("AAG1400_DRAG result:", JSON.stringify(result));

    // dropped outside the list
    if (!result.destination) {
      console.log("AAG1400_DRAG: no destination - rbd rejected the drop");
      return;
    }

    const { form } = this.props;
    const ColumnKeys = form.getFieldValue("ColumnKeys");
    console.log("AAG1400_DRAG: ColumnKeys", JSON.stringify(ColumnKeys));

    const currentOrder = this.getColumnKeyOrder(ColumnKeys);
    console.log("AAG1400_DRAG: currentOrder before reorder", JSON.stringify(currentOrder));

    const reorderedKeys = Array.from(currentOrder);
    const [movedKey] = reorderedKeys.splice(result.source.index, 1);
    reorderedKeys.splice(result.destination.index, 0, movedKey);
    console.log("AAG1400_DRAG: reorderedKeys after reorder", JSON.stringify(reorderedKeys));

    this.setState({ columnDragOrder: reorderedKeys }, () => {
      console.log("AAG1400_DRAG: state.columnDragOrder is now", JSON.stringify(this.state.columnDragOrder));
    });
  }

  removeColumn = k => {
    const { form } = this.props;
    // can use data-binding to get
    const ColumnKeys = form.getFieldValue("ColumnKeys");
    if (ColumnKeys.length === 1) {
      return;
    }

    const orderedKeys = this.getColumnKeyOrder(ColumnKeys);
    const columnKeyToRemove = orderedKeys[k];

    form.setFieldsValue({
      ColumnKeys: ColumnKeys.filter(key => key !== columnKeyToRemove)
    });

    this.setState(prevState => ({
      columnDragOrder: Array.isArray(prevState.columnDragOrder)
        ? prevState.columnDragOrder.filter(key => key !== columnKeyToRemove)
        : prevState.columnDragOrder
    }));
  };

  onDragEnd = result => {
    const { destination, source, draggableId, type } = result;
    if (!destination) {
      return;
    }
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    if (destination.index == 0) {
      return;
    }
    if (type === "column") {
      const newcolumnId = Array.from(this.state.columnId);
      newcolumnId.splice(source.index, 1);
      newcolumnId.splice(destination.index, 0, draggableId);
      const newState = {
        ...this.state,
        columnId: newcolumnId
      };
      this.setState(newState);
      return;
    }

    if (type === "fields") {
      const newFieldGroup = Array.from(
        this.state.fieldsgroup[destination.droppableId]
      );
      newFieldGroup.splice(source.index, 1);
      newFieldGroup.splice(
        destination.index,
        0,
        parseInt(draggableId.split(":")[1])
      );
      let obj = {
        [destination.droppableId]: newFieldGroup
      };
      this.setState({
        fieldsgroup: { ...this.state.fieldsgroup, ...obj }
      });
      this.child.reloadOnfield(obj);
      return;
    }
  };

  remove = k => {
    const { form } = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue("keys");
    // We need at least one passenger
    if (keys.length === 1) {
      //return;
    }
    // can use data-binding to set
    form.setFieldsValue({
      keys: keys.filter(key => key !== k)
    });

    const nextKeys = keys.filter(key => key !== k);
    this.setState({
      columnId: nextKeys.map(data => `groupId:` + data),
      columIdByChield: nextKeys.map(data => `groupId:` + data)
    });
  };

  add = () => {
    const { form } = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue("keys");
    console.log(keys);
    const nextKeys = keys.concat(uid++);
    console.log(nextKeys);
    // can use data-binding to set
    // important! notify form to detect changes
    form.setFieldsValue({
      keys: nextKeys
    });

    this.setState({
      columnId: nextKeys.map(data => `groupId:` + data)
    });
  };


  removeDuplicateColumns = (columnArray) => {
    const seen = new Set();
    return columnArray
      .filter(col => col && !INTERNAL_ONLY_COLUMNS.includes(col.toLowerCase()))
      .filter(col => {
        const lower = col.toLowerCase();
        if (seen.has(lower)) return false;
        seen.add(lower);
        return true;
      });
  };

  handleColumnSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const ColumnKeys = this.props.form.getFieldValue("ColumnKeys");
        const orderedColumns = this.getColumnKeyOrder(ColumnKeys)
          .map(key => (values.columns && values.columns[key]) || this.state.columnKeyValues[key])
          .filter(Boolean);

        let filter = this.state.filters

        const refinedColumns = this.removeDuplicateColumns(orderedColumns);
        const priorColumns = new Set(
          (this.state.savedpreferenceColumns || []).filter(Boolean).map(c => c.toLowerCase())
        );
        const dynamicColumns = refinedColumns
          .map(c => c && (this.mapToApiColumnName(c) || (priorColumns.has(c.toLowerCase()) ? c.toLowerCase() : null)))
          .filter(c => c && !INTERNAL_ONLY_COLUMNS.includes(c));

        this.getcolumnlist(dynamicColumns);
        this.setState({
          columns: dynamicColumns,
          changecolumnvisible: false,
          columnlist: dynamicColumns,
          savedpreferenceColumns: dynamicColumns,
          uuid: 0,
          searched: true,
          columnDragOrder: null
        });
        
        // if (this.state.preference && Array.isArray(this.state.preference.Expressions) && this.state.preference.Expressions.length > 0) {
        //   filter = this.state.preference;
        // } 
        
        
        
        // this.props.actions.savelist(filter, this.state.savedpreference ? this.state.savedpreference : 'advancedsearch', this.state.savedpreferenceType ? this.state.savedpreferenceType : '4', refinedColumns, false, this.state.perPageSize, this.state.currentpage, this.props.maxRecords, null, this.state.isEaglesOnly)

        this.props.actions.getAdvancedSearchResults(filter, dynamicColumns, this.props.maxRecords, this.state.currentpage, this.state.perPageSize, this.props.TotalRecordCount)
        if (ColumnKeys.length != 0) {
          this.props.form.setFieldsValue({
            ColumnKeys: []
          });
        }
      }
    });
  };

  onShowSizeChange = (current, pageSize) => {
    this.setState({
      currentpage: 1,
      perPageSize: pageSize,
  }) 

    let filter = this.state.filters
    if (this.state.preference && Array.isArray(this.state.preference.Expressions) && this.state.preference.Expressions.length > 0) {
      filter = this.state.preference;
    }
    let columnList = this.state.columnlist
    if (Array.isArray(columnList.DisplayColumnLists) && columnList.DisplayColumnLists.length > 0) {
      columnList = columnList.map(item => {
      if (typeof item === "object") {
        // If item is an object, extract the first key-value pair's value
        return Object.entries(item)[0][1];
      } else {
        // If it's not an object, just return the item itself
        return item;
      }
    })
  }

  const refinedColumns = this.removeDuplicateColumns(columnList);
  const dynamicColumns = this.getDynamicColumns(refinedColumns)
  this.props.actions.getAdvancedSearchResults(filter, dynamicColumns, this.props.maxRecords, current, pageSize, this.props.TotalRecordCount)

//     this.props.actions.savelist(filter,'advancedsearch', '4', refinedColumns, false, pageSize, current, this.props.maxRecords, null, this.state.isEaglesOnly)

}

  isLastPageOutsideLoadedRecords = (page, perPageSize) => {
    const loadedRecords = this.props.maxRecords || 0;
    const totalPages = Math.ceil((Number(getTotalRecordCount) || 0) / perPageSize);
    return page === totalPages && Number(getTotalRecordCount) > loadedRecords;
  };

  paginationItemRender = (page, type, originalElement) => {
    if (type !== "page") {
      return originalElement;
    }
    const perPageSize = this.state.perPageSize;
    if (this.isLastPageOutsideLoadedRecords(page, perPageSize)) {
      return (
        <Tooltip title="This page is outside the currently loaded records. Please navigate through the available pages.">
          <span
            className="ant-pagination-item-link"
            style={{ cursor: "not-allowed", color: "rgba(0, 0, 0, 0.25)" }}
          >
            {page}
          </span>
        </Tooltip>
      );
    }
    return originalElement;
  };

  onChange = (page, pageSize) => {
    if (this.isLastPageOutsideLoadedRecords(page, pageSize)) {
      return;
    }
    this.setState({
      currentpage: page,
      perPageSize: pageSize,
  })
    let filter = this.state.filters
    if (this.state.preference && Array.isArray(this.state.preference.Expressions) && this.state.preference.Expressions.length > 0) {
      filter = this.state.preference;
    }
    // const refinedColumns = this.removeDuplicateColumns(this.state.columnlist);
    const refinedColumns = [...new Set(this.state.columnlist)];

    const dynamicColumns = this.getDynamicColumns(refinedColumns)
    this.props.actions.getAdvancedSearchResults(this.state.filters, dynamicColumns, this.props.maxRecords, page, pageSize, this.props.TotalRecordCount) //1264 need isEaglesOnly filter in API
    // this.props.actions.savelist(filter, 'advancedsearch', '4', refinedColumns, false, pageSize, page, this.props.maxRecords, null, this.state.isEaglesOnly)
  }

  modifyExpiression = expressions => {
    let modifiedExpressions = [...expressions];

    modifiedExpressions.forEach((data, i) => {
      if(["NULL", "NOTNULL", "NE"].includes(expressions[i]["Operator"])){
        return data;
      }
      else {
      //Add leading zeroes, when necessary, to make the searchable unit number 4 digits long
      if (expressions[i]["ColumnName"] == "eaglescoutunitnumber") {
        let unitNumber = expressions[i]["Value"];
        while (unitNumber.length < 4) unitNumber = "0" + unitNumber;
        expressions[i]["Value"] = unitNumber;
      }
      if (
        expressions[i]["ColumnName"].includes("date") ||
        expressions[i]["ColumnName"].includes("dt") ||
        expressions[i]["ColumnName"].includes("Date")
      ) {
        let formateddate = moment(data.Value, "MM-DD-YYYY").format(
          "YYYYMMDD"
        );
        data.Value = formateddate + "000000";
      }
      if (expressions[i]["ColumnName"].includes("state") && Array.isArray(data.Value)) {
        // Multi-select (e.g. EagleScoutUnitState's "range"/InList operator) already
        let allstates = this.props.allstates ? this.props.allstates : [];
        let invalid = data.Value.some(
          v => !allstates.some(e => e.short === String(v).toUpperCase())
        );

        if (invalid) {
          notification["error"]({
            message: "Error",
            description: "Please Enter the valid State Name."
          });
        }
      } else if (expressions[i]["ColumnName"].includes("state")) {
        let isStateShortcode = data.Value ? data.Value.length : 0;
        let allstates = this.props.allstates ? this.props.allstates : [];

        if (
          expressions[i]["ColumnName"] == "nesa_state" ||
          expressions[i]["ColumnName"] == "eaglescoutunitstate"
        ) {
          if (isStateShortcode == 2) {
            let filteredState = allstates.filter(
              e => e.short === data.Value.toUpperCase()
            );
            let stateValue =
              filteredState.length != 0
                ? filteredState[0].name.split("-")[1]
                : "";
            if (stateValue == "") {
              notification["error"]({
                message: "Error",
                description: "Please Enter the valid State Name."
              });
            }
          } else {
            //let filteredState = allstates.filter((e) => e.name.split('-')[1] === data.Value.toUpperCase())
            let selectedstate = allstates.filter(function(state) {
              return state.name.split("-")[1] === data.Value.toUpperCase();
            });
            let selectedStateValue =
              selectedstate.length != 0 ? selectedstate[0].short : "";
            data.Value = selectedStateValue;
            if (selectedStateValue == "") {
              notification["error"]({
                message: "Error",
                description: "Please Enter the valid State Name."
              });
            }
          }
        } else if (expressions[i]["ColumnName"] == "home_state") {
          let filteredState = allstates.filter(
            e => e.short === data.Value.toUpperCase()
          );
          let stateValue =
            filteredState.length != 0
              ? filteredState[0].name.split("-")[0]
              : "";
          data.Value = stateValue;
        } else {
          if (isStateShortcode == 2) {
            let filteredState = allstates.filter(
              e => e.short === data.Value.toUpperCase()
            );
            let stateValue =
              filteredState.length != 0
                ? filteredState[0].name.split("-")[1]
                : "";
            data.Value = stateValue;
            if (stateValue == "") {
              notification["error"]({
                message: "Error",
                description: "Please Enter the valid State Name."
              });
            }
          } else {
            let isState = allstates.filter(e => {
              if (
                e.name
                  .toUpperCase()
                  .split("-")
                  .includes(data.Value.toUpperCase())
              ) {
                return true;
              }
              return false;
            });
            if (isState.length == 0) {
              notification["error"]({
                message: "Error",
                description: "Please Enter the valid State Name."
              });
            }
          }
        }
      }
    }
    });

    return modifiedExpressions;
  }

// buildGroupQueries = (values) => {// -------------Works with multiple OR operators----------------
//   const groups = this.extractGroups(values);
  
//   let queries = [], columns = [];

//   groups.forEach(group => {
//     const cleaned = this.cleanFilters(group); 

//     columns.push(cleaned.map(item => item.column).filter(Boolean));

//     const optimized = this.optimizeOrBlocks(cleaned);

//     optimized.forEach(q => {
//       const noConflicts = this.removeConflicts(q);

//       const queryString = this.buildQueryString(noConflicts);

//       if (queryString) {
//         queries.push(queryString);
//       }
//     });
//   });

//   queries = this.uniqueQueries(queries);

//   if (queries.length > 5) {
//     return {
//       error: true,
//       message: `Too many API calls (${queries.length}). Reduce OR filters.`
//     };
//   }
//   const uniqueColumns = [...new Set(columns.flat())];

//   return {
//     error: false,
//     queries, 
//     uniqueColumns
//   };
// };

// optimizeOrBlocks = (filters) => {
//   const orFilters = [];
//   const andFilters = [];

//   filters.forEach((f, i) => {
//     if (i === 0 || f.scope === "OR") {
//       orFilters.push(f);
//     } else {
//       andFilters.push(f);
//     }
//   });

//   // Group OR filters by column + operator
//   const grouped = {};

//   orFilters.forEach(f => {
//     const key = `${f.column}_${f.operator}`;
//     if (!grouped[key]) grouped[key] = [];
//     grouped[key].push(f.value);
//   });

//   // Build optimized OR queries
//   const optimizedOr = [];

//   Object.entries(grouped).forEach(([key, values]) => {
//     const [column, operator] = key.split("_");

//     if (operator === "EQ") {
//   if (values.length > 1) {
//     optimizedOr.push([{
//       column,
//       operator: "INLIST",
//       value: values
//     }]);
//   } else {
//     optimizedOr.push([{
//       column,
//       operator: "EQ",
//       value: values[0]
//     }]);
//   }
// }

//     else if (operator === "Contains") {
//       optimizedOr.push([{
//         column,
//         operator: "ContainsList",
//         value: values
//       }]);
//     }

//     else {
//       values.forEach(v => {
//         optimizedOr.push([{ column, operator, value: v }]);
//       });
//     }
//   });

//   return optimizedOr.map(orGroup => [...orGroup, ...andFilters]);
// };
// removeConflicts = (filters) => {
//   const seen = {};

//   return filters.filter(f => {
//     const key = f.column;

//     if (!seen[key]) {
//       seen[key] = f;
//       return true;
//     }

//     // conflict: same column with different value
//     if (seen[key].value !== f.value) {
//       return false;
//     }

//     return true;
//   });
// };

// estimateQueryCount = (groups) => {
//   let count = 0;

//   groups.forEach(group => {
//     let groupCount = 1;

//     group.forEach((f, i) => {
//       if (i === 0) return;

//       if (this.isOrBetween(group[i - 1], f)) {
//         groupCount *= 2;
//       }
//     });

//     count += groupCount;
//   });

//   return count;
// };
  
//   uniqueQueries = (queries) => {
//     return [...new Set(queries)];
//   };
  
//   extractGroups = (values) => {
//     return Object.keys(values)
//     .filter(k => k.startsWith("groupfiltergroupId"))
//     .map(groupKey => {
//       return values[groupKey].map(i => ({
//         column: values[`filtercolumn${i}`],
//         operator: values[`filteroperator${i}`],
//         value: values[`filtervalue${i}`],
//         scope: values[`filterscope${i}`] || null,
//         groupOperator: values[`groupoperator${i}`] || null,
//         index: i
//       }));
//     });
//   };

//   expandGroup = (filters) => {
//     let result = [[]];

//     filters.forEach(filter => {
//       const isOR =
//         filter.scope === "OR" ||
//         filter.groupOperator === "OR";
  
//       if (filter.operator === "INLIST") {
//         result = result.map(r => [...r, filter]);
//         return;
//       }
  
//       if (isOR) {
//         const newResult = [];
  
//         result.forEach(r => {
//           newResult.push([...r]);           // skip
//           newResult.push([...r, filter]);   // include
//         });
  
//         result = newResult;
//       } else {
//         result = result.map(r => [...r, filter]);
//       }
//     });
  
//     return result;
//   };

  
  buildQueryString = (filters) => {
    return filters.map(f => {
      if (f.operator === "EQ") {
        return `${f.column}=${encodeURIComponent(f.value)}`;
      }
  
      if (f.operator === "Contains") {
        return `${f.column}Contains=${encodeURIComponent(f.value)}`;
      }
  
      if (f.operator === "ContainsList") {
        return `${f.column}ContainsList=${f.value.map(v => encodeURIComponent(v)).join(",")}`;
      }
  
      if (f.operator === "INLIST") {
        let values = [];

        if (typeof f.value === "string") {
          values = f.value
            .split(",")
            .map(v => v.trim())
            .filter(Boolean);
        } else if (Array.isArray(f.value)) {
          values = f.value
            .map(v => String(v).trim())
            .filter(Boolean);
        }

        return `${f.column}INLIST=${values
          .map(v => encodeURIComponent(v))
          .join(",")}`;
      }
  
      return "";
    }).filter(Boolean).join("&");
  };

  cleanFilters = (filters) => {
    return filters.filter(f =>
      f &&
      f.column &&
      f.operator &&
      f.value !== undefined &&
      f.value !== null &&
      f.value !== ""
    );
  };

  isOrBetween = (prev, current) => {
    return (
      current.scope === "OR" ||
      current.groupOperator === "OR"
    );
  };

  buildSimpleQuery = (values) => {
    const filters = this.normalizeFilters(values);
  
    const uniqueColumns = this.getUniqueColumns(filters);
  
    const grouped = this.groupFilters(filters);
  
    const queries = this.buildSingleQuery(grouped);
  
    // Boolean filters (except AlumniPrivacy, which the action always adds) are also requested as columns.
    const booleanColumns = [
      ...new Set(
        filters
          .map(({ column }) => (column || "").toLowerCase())
          .filter(col => BooleanFilters.includes(col) && col !== "alumniprivacy")
      ),
    ];

    return {
      queries: [queries],
      uniqueColumns,
      booleanColumns
    };
  };

 getUniqueColumns = (filters) => {
  return [
    ...new Set(
      filters
        .map(({ column }) => {
          const lowerColumn = column.toLowerCase();

          // Boolean filters are sent as query params, not requested columns.
          if (BooleanFilters.includes(lowerColumn)) {
            return null;
          }

          if (lowerColumn === "skpersonid") {
            return "memberid";
          }
          if (lowerColumn === "nationalawardid") {
            return "nationalaward";
          }
          // ID filter columns are query-only; the table shows the name column.
          if (lowerColumn === "affinitygroupid") {
            return "affinitygroup";
          }
          if (lowerColumn === "scoutingaffiliationid") {
            return "scoutingaffiliation";
          }

          // The API's state columns (home_state, nesa_state, business_state, ...) are
          // underscored, but the filtercolumn Select value for them isn't (homestate,
          // nesastate, businessstate, ...) - insert the underscore back so we send the
          // one real column name instead of both spellings. eaglescoutunitstate is the
          // one exception - its API field genuinely has no underscore.
          if (lowerColumn.includes("state") && !lowerColumn.includes("_state") && lowerColumn !== "eaglescoutunitstate") {
            return lowerColumn.replace("state", "_state");
          }

          return column;
        })
        .filter(Boolean)
    ),
  ];
};

  normalizeFilters = (values) => {
    const filters = [];
  
    values["groupfiltergroupId:0"].forEach(i => {
      const column = values[`filtercolumn${i}`];

      // AffinityGroup / ScoutingAffiliation values are lookup IDs for exact-match
      // operators, so they go to the API as the ID columns.
      const idColumn = ID_FILTER_COLUMNS[column.toLowerCase()];
      const isIdOperator = ID_FILTER_OPERATORS.includes(String(values[`filteroperator${i}`] || '').toLowerCase().replace(/\s/g, ''));

      const filter = {
        column: idColumn && isIdOperator ? idColumn : values[`filtercolumn${i}`].toLowerCase() == 'memberid' ? 'SKPersonID' : values[`filtercolumn${i}`],
        operator: values[`filteroperator${i}`],
        value: values[`filtervalue${i}`]
      }
      filters.push(filter);

      if (column.toLowerCase() === 'communityorganizationcategorycode') {
        const extraValue = values[`communityorganizationname_${i}`];

        if (extraValue) {
          filters.push({
            column: 'communityorganizationtypename',
            operator: values[`filteroperator${i}`],
            value: extraValue
          });
        }
      }
       
    });
  
    return filters;
  };

  groupFilters = (filters) => {
  const map = {};

  filters.forEach((f) => {
    let { column, operator, value } = f;

    if (
      column.toLowerCase() === "nesastate" &&
      operator.toLowerCase().includes("bv")
    ) {
      column = "nesa_state";
    }

    const key = `${column}_${operator}`;

    if (!map[key]) {
      map[key] = [];
    }

    map[key].push(value);
  });

  return map;
};

  buildSingleQuery = (grouped) => {
    const params = [];
  
    Object.entries(grouped).forEach(([key, values]) => {
      const lastIndex = key.lastIndexOf("_");

      const column = key.slice(0, lastIndex);
      let operator = key.slice(lastIndex + 1);

      operator = operator.replace(/\s/g, ''); //remove whiteSpaces
      let filteroperator = operator.toLowerCase().trim()

      // National award values are numeric NationalAwardID lookup ids, so don't
      // trim/strip whitespace out of them like other filter values.
      const isNationalAward = column.toLowerCase() === 'nationalawardid';

      if(column.toLowerCase() == 'phonenumber'){
        // Each grouped row's value may itself be a comma-joined list of "countryID number"
        // pairs (InList). Strip non-digits within each pair but keep the commas that
        // separate numbers, and keep every row's value instead of only the first.
        values = values.map(v =>
          v.split(",").map(pair => pair.replace(/\D/g, "")).join(",")
        );
      }

      if (column.toLowerCase() == 'affinitygroup') {
        // InList submits one array per row (multi-select) alongside possibly several
        // rows, so flatten first instead of only ever looking at the first row's value.
        const flatValues = values.reduce((acc, v) => acc.concat(Array.isArray(v) ? v : [v]), []);

        values = flatValues.map(v => {
          const trimmed = v.trim();
          return trimmed.endsWith(',') ? trimmed : trimmed + ',';
        });
      }

      // The council Select always submits the council's long name, but the councilnumber
      // column expects the numeric council number, so map name -> number here.
      if (column.toLowerCase().includes('councilnumber') && Array.isArray(this.props.councils)) {
        const mapToCouncilNumber = (v) => {
          const match = this.props.councils.find(c => c.councilLong === v);
          return match ? String(match.councilNumber) : v;
        };

        values = values.map(v => Array.isArray(v) ? v.map(mapToCouncilNumber) : mapToCouncilNumber(v));
      }

      // For the CouncilName field (not CouncilNameAndNumber), the report/search expects only the council name, without any council number. 
      // Greater Alabama Council 001 --> Greater Alabama Council
      if (column.toLowerCase().includes('councilname') && !column.toLowerCase().includes('councilnameandnumber')) {
        const stripCouncilNumber = (v) => typeof v === 'string' ? v.replace(/\s*#?\d+\s*$/, '').trim() : v;

        values = values.map(v => Array.isArray(v) ? v.map(stripCouncilNumber) : stripCouncilNumber(v));
      }

      //------------ create formula ------------
      if (filteroperator === "nbv" || filteroperator === "bv") {
          params.push(
            `${column}${filteroperator}=1`
          );
      }
      else if ((column.toLowerCase().includes('date') || column.toLowerCase().includes('dt'))) {
        if (filteroperator == 'range') {
          values = values[0].map(dt => moment(dt).format('YYYY-MM-DDTHH:mm:ss')).join(' - ');
        } else {
          values = moment(values[0]).format('YYYY-MM-DDTHH:mm:ss');
        }
        params.push(`${filteroperator === "equals" ? `${column}` : `${column}${filteroperator}`}=${encodeURIComponent(values)}`)
      }

      else  if (BooleanFilters.includes(column)) {
       params.push(`${column}=${encodeURIComponent(values[0])}`)
      }

      else if (filteroperator === "equals") {
        // A multi-select InList-capable dropdown submits its row's value as an array,
        // so flatten before treating each entry as its own value to join/encode.
        const flatValues = values.reduce((acc, v) => acc.concat(Array.isArray(v) ? v : [v]), []);

        if (flatValues.length > 1) {
          params.push(
            `${column}INLIST=${flatValues.map(v => encodeURIComponent(isNationalAward ? v : v.trim())).join(",")}`
          );
        } else {
          params.push(
            `${column}=${`${encodeURIComponent(isNationalAward ? flatValues[0] : flatValues[0].trim())}`}`
          );
        }
      }
      else if (filteroperator === "inlist") {
        const flatValues = values.reduce((acc, v) => acc.concat(Array.isArray(v) ? v : [v]), []);

        // Trim whitespace surrounding each comma-separated item (and the whole value) but keep
        // inner spaces intact, e.g. " John  Smith , Jane " -> "John  Smith,Jane". A trailing
        // comma is preserved.
        const trimItems = v =>
          isNationalAward ? v : String(v).split(",").map(item => item.trim()).join(",");

        params.push(
          `${column}INLIST=${flatValues.map(v => encodeURIComponent(trimItems(v))).join(",")}`
        );
      }
      
      // Non-date/zip columns (currently just EagleScoutUnitState) reuse the "range"
      // operator as a multi-select, so flatten and comma-join like INLIST does
      // instead of falling into the single-value fallback below, which can't
      // handle an array value.
      else if (filteroperator === 'range') {
        const flatValues = values.reduce((acc, v) => acc.concat(Array.isArray(v) ? v : [v]), []);

        params.push(
          `${column}${filteroperator}=${flatValues.map(v => encodeURIComponent(v.trim())).join(",")}`
        );
      }

      // if (filteroperator === "eq") {
      //   if (values.length > 1) {
      //     params.push(
      //       `${column}INLIST=${values.map(v => encodeURIComponent(v)).join(",")}`
      //     );
      //   } else {
      //     params.push(
      //       `${column}=${encodeURIComponent(values[0])}`
      //     );
      //   }
      // }

      // if (filteroperator === "doesnotmatch") {
      //   if (values.length > 1) {
      //     params.push(
      //       `${column}INLIST=${values.map(v => encodeURIComponent(v)).join(",")}`
      //     );
      //   } else {
      //     params.push(
      //       `${column}=${encodeURIComponent(values[0])}`
      //     );
      //   }
      // }
      
      // else if (filteroperator === "contains") {
      //   if (values.length > 1) {
      //     params.push(
      //       `${column}ContainsList=${values.map(v => encodeURIComponent(v)).join(",")}`
      //     );
      //   } else {
      //     params.push(
      //       `${column}Contains=${encodeURIComponent(values[0])}`
      //     );
      //   }
      // }
  
      // else if (filteroperator === "doesnotcontain") {
      //   if (values.length > 1) {
      //     params.push(
      //       `${column}DoesNotContainList=${values.map(v => encodeURIComponent(v)).join(",")}`
      //     );
      //   } else {
      //     params.push(
      //       `${column}DoesNotContain=${encodeURIComponent(values[0])}`
      //     );
      //   }
      // }
      // else if (filteroperator.toLowerCase() === "startswith") {
      //   if (values.length > 1) {
      //     params.push(
      //       `${column}StartsWithList=${values.map(v => encodeURIComponent(v)).join(",")}`
      //     );
      //   } else {
      //     params.push(
      //       `${column}StartsWith=${encodeURIComponent(values[0])}`
      //     );
      //   }
      // }
      // else if (filteroperator.toLowerCase() === "doesnotstartwith") {
      //   if (values.length > 1) {
      //     params.push(
      //       `${column}DoesNotStartWithList=${values.map(v => encodeURIComponent(v)).join(",")}`
      //     );
      //   } else {
      //     params.push(
      //       `${column}DoesNotStartWith=${encodeURIComponent(values[0])}`
      //     );
      //   }
      // }

      //AAG-1264 ask Oleg how to pass the social Media filter
      // else if (column == 'socialmedia' && filteroperator.toLowerCase() === "Has") { 
      //   if (values.length > 1) {
      //     params.push(
      //       `${column}DoesNotStartWithList=${values.map(v => encodeURIComponent(v)).join(",")}`
      //     );
      //   } else {
      //     params.push(
      //       `${column}DoesNotStartWith=${encodeURIComponent(values[0])}`
      //     );
      //   }
      // }
  
      else {
        values.forEach(v => {
          params.push(`${column}${filteroperator}=${encodeURIComponent(isNationalAward ? v : v.trim())}`);
        });
      }
    });

    return params.join("&");
  };

  // Translates an internal/legacy column name (e.g. "HomeCity", "CommunityOrganizationCategoryName")
  // into the real column name the report API returns from getNewReportColumn (e.g. "home_city", "commorgcatlong").
  mapToApiColumnName = (name) => {
    if (!name || !Array.isArray(this.props.getNewReportColumn)) {
      return null;
    }

    const normalize = (str) => str && str.toLowerCase().replace(/_/g, "");
    const lower = name.toLowerCase();

    if (REVERSE_REPORT_COLUMN_ALIASES[lower]) {
      return REVERSE_REPORT_COLUMN_ALIASES[lower];
    }

    const match = this.props.getNewReportColumn.find(col => normalize(col.name) === normalize(name));
    return match ? match.name.toLowerCase() : null;
  };

  getDynamicColumns = (list = []) => {
    if (
      this.props.getNewReportColumnLoading ||
      !Array.isArray(this.props.getNewReportColumn) ||
      this.props.getNewReportColumn.length <= 0
    ) {
      return;
    }

    return list
      .filter(name => name && !INTERNAL_ONLY_COLUMNS.includes(name.toLowerCase()))
      .map(name => this.mapToApiColumnName(name))
      .filter(Boolean);
  };

  handleSubmit = e => {
    const {ethnicities} = this.props;

    e.preventDefault();

    if (this.props.advancedRecordsLoading) {
      return;
    }

    this.props.form.validateFields((err, values) => {
      if (!err) {
        // const queries = this.buildApiFilters(values);
        // const processedValues = this.autoConvertToInList(values);
        const { error, message, queries, uniqueColumns, booleanColumns } = this.buildSimpleQuery(values);

        let columnlist = uniqueColumns;

        let ColumnsArray = columnlist
          // .filter(col => col && col !== 'councilnumber') AAG-1407 
          .map(col => col.toLowerCase());

        const requiredColumns = ["firstname", "lastname", "home_state"];

        ColumnsArray = [...new Set([...requiredColumns, ...ColumnsArray, ...booleanColumns])];
        columnlist = [...new Set([...requiredColumns, ...columnlist, ...booleanColumns])];

        console.log("ColumnsArray:", ColumnsArray);
        console.log("columnlist:", columnlist);


        const maxRecord = 5000;

        if (error) {
          return notification.open({
            message: 'Too many combinations',
            description: message,
            icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
          });
        }

        const dynamicColumns = [...new Set(
          ColumnsArray.map(col => this.mapToApiColumnName(col) || col)
        )];
        this.getcolumnlist(dynamicColumns);
        this.setState(prevState => ({
          currentpage: prevState.currentpage !== 1 ? 1 : prevState.currentpage,
          filters: queries,
          columnlist,
          columns: dynamicColumns,
          savedpreferenceColumns: dynamicColumns,
          searched: true
        }))


        this.props.actions.getAdvancedSearchResults(queries, dynamicColumns, maxRecord, 1, this.state.perPageSize)

        console.log('queries', queries)
        if(false){
          let Query = "";
        let getCouncilNumber;
        let groupfilterArray = values["groupfiltergroupId:0"];
        let queryscopefilter = [];
        let queryfilter = [];
        let queryfilterlist = [];
        let newgroupArray = values["keys"];
        let formula = "";
        let expressions = [];
        let expno = 0;
        let columnlist = [];
        let councilNumberFilterColNumber;
        newgroupArray.map(key => {
          if (
            values["groupoperator" + values["groupfiltergroupId:" + key][0]]
          ) {
            Query +=
              "\t" +
              values["groupoperator" + values["groupfiltergroupId:" + key][0]] +
              "\t";
            formula +=
              " " +
              values["groupoperator" + values["groupfiltergroupId:" + key][0]] +
              " ";
          }

          Query += "(";
          formula += "(";

          values["groupfiltergroupId:" + key].map((k, index) => {
            
            const operator = values["filteroperator" + k];
            const value = values["filtervalue" + k];
            // let NOTNULL_operatorsIndex = expno;
            // let isNOTNullOperatorSelected = false;
            // if(operator === "NOTNULL"){
            //   NOTNULL_operatorsIndex++;
            //   isNOTNullOperatorSelected = true
            // }

            if (values["filtercolumn" + k] == "councilnumber") {  // take the councilNumber filter out of the standard expressions and filters format and pass it as form data if it is selected.
              getCouncilNumber = values["filtervalue" + k].match(/\d+/)[0];
              councilNumberFilterColNumber = k;
            }
            else {
            

              Query +=
              [values["filterscope" + k] ? values["filterscope" + k] : " ",
                values["filtercolumn" + k],
                values["filteroperator" + k],
                (!["NULL", "NOTNULL", "NE"].includes(operator)) ? values["filtervalue" + k] : ''
              ].join(" ");
              

                // if (councilNumberFilterColNumber == 0) {
                //   formula += " " + "@exp" + expno + " ";
                // } else {
                  formula += [values["filterscope" + k] ? values["filterscope" + k] : " "] + " " + "@exp" + expno + " ";
                // }
                // if(isNOTNullOperatorSelected){
                //   formula += [values["filterscope" + k] ? values["filterscope" + k] : " "] + " " + "@exp" + NOTNULL_operatorsIndex + " ";
                // }


                // let expFor_NULL_OR_NOTNULL = [];

                // if (isNOTNullOperatorSelected) {
                //   expFor_NULL_OR_NOTNULL = [
                //     {
                //       ExpressionName: "exp" + expno,
                //       ColumnName: values["filtercolumn" + k],
                //       Operator: operator,
                //     },
                //     {
                //       ExpressionName: "exp" + NOTNULL_operatorsIndex,
                //       ColumnName: values["filtercolumn" + k],
                //       Operator: "<>",
                //       Value: ""
                //     }
                //   ];
                // }
                
                // if (operator !== "NULL" && operator !== "NOTNULL") {
                  expressions.push({
                    ExpressionName: "exp" + expno,
                    ColumnName: values["filtercolumn" + k],
                    Operator: operator,
                    ...(!["NULL", "NOTNULL", "NE"].includes(operator)
                  ? { Value: value }
                  : {})
                  });
              //   }
                
              //   if (isNOTNullOperatorSelected) {
              //     expressions.push(...expFor_NULL_OR_NOTNULL);
              //   }
                
                       
              // expno = isNOTNullOperatorSelected ? isNOTNullOperatorSelected + 1 : expno++;
              expno++;
              queryscopefilter.push({
                scopecolumn: values["filtercolumn" + k],
                scopeoperator: operator,
                ...(!["NULL", "NOTNULL", "NE"].includes(operator)
                  ? { scopevalue: value }
                  : {})
              });
            }
            columnlist.push(values["filtercolumn" + k].toLowerCase());
          });

            formula += ")";
            Query += ")";
         
        });
        const modifiedExpressions = this.modifyExpiression(expressions);

        if (hasNationalAwardColumn(columnlist) && !columnlist.includes("nationalaward")) {
          columnlist.push("nationalaward");
        }

        let ColumnsArray = [null];
        let columns = columnlist;
        delete ColumnsArray[0];
        if (columns) {
          columns.forEach((k, index) => {
            if (k !== 'councilnumber') {
              ColumnsArray.push(k.toLowerCase());
            }
          });
        }

        if(!ColumnsArray.includes("firstname")) {
          ColumnsArray.push("firstname");
        }
        if(!columnlist.includes("firstname")) {
          columnlist.push("firstname");
        }
        if(!ColumnsArray.includes("lastname")) {
          ColumnsArray.push("lastname");
        }
        if(!columnlist.includes("lastname")) {
          columnlist.push("lastname");
        }
        if(!ColumnsArray.includes("home_state")) {
          ColumnsArray.push("home_state");
        }
        if(!columnlist.includes("home_state")) {
          columnlist.push("home_state");
        }


        // ColumnsArray.includes("firstname") ? "" : ColumnsArray.push("firstname");
        // columnlist.includes("firstname") ? "" : columnlist.push("firstname");

        // ColumnsArray.includes("lastname") ? "" : ColumnsArray.push("lastname");
        // columnlist.includes("lastname") ? "" : columnlist.push("lastname");

        // ColumnsArray.includes("home_state") ? "" : ColumnsArray.push("home_state");
        // columnlist.includes("home_state") ? "" : columnlist.push("home_state");

        // ColumnsArray.includes('personguid') ? "" : ColumnsArray.push('personguid')
        // columnlist.includes('personguid') ? "" : columnlist.push('personguid')

        console.log("Show List Results Submit - Columns State", ColumnsArray);
        console.log("Show List Results Submit - ColumnList State", columnlist);

        const refinedColumns = this.removeDuplicateColumns(columnlist);
        const refinedColumnsArray = this.removeDuplicateColumns(ColumnsArray);

        queryfilterlist = queryscopefilter.concat(queryfilter);
       

        // AAG-887 when scout affiliation = nesa selected, we pass a dummy expression value and pass a reported param instead.
        // Also, if multiple 
        let maxRecord = 0;
        // let columnList = this.state.savedpreferenceColumns.length == 0 ? columnlist : this.state.savedpreferenceColumns
        if(expressions) {
          let columnName = "membershipstatus";
          let value = 'active';

          expressions.forEach(function(obj) {
            if (obj.Value === "National Eagle Scout Association") {
              obj.ColumnName = columnName;
              obj.Value = value; 
              maxRecord = 5000;
            }
            if (obj.ColumnName.toLowerCase() === "ethnicity" && (!["NULL", "NOTNULL", "NE"].includes(obj.Operator))) {
              obj.ColumnName = "EthnicityID";
              const ethnicity = ethnicities.find(item => item.name.toLowerCase() === obj.Value.toLowerCase());
              
              if (ethnicity) {
                  obj.Value = ethnicity.id; // Set the id from the ethnicity object
              }
          }
          })
        } 
        this.state.preference.Formula = formula
        this.state.preference.Expressions = expressions
        this.getcolumnlist(refinedColumns)
        
        this.setState(prevState => ({
          currentpage: prevState.currentpage !== 1 ? 1 : prevState.currentpage,
          getCouncilNumber : getCouncilNumber,
          query: Query,
          formula: formula,
          expressions: modifiedExpressions,
          queryfilterlist: queryfilterlist,
          columnlist: refinedColumns,
          columns: refinedColumnsArray,
          savedpreferenceColumns: refinedColumnsArray
        }))

        this.props.actions.savelist(this.state.preference, 'advancedsearch', '4', refinedColumns, false, this.state.perPageSize, 1, maxRecord, getCouncilNumber, this.state.isEaglesOnly)
      }
      }
    });
  };

  listTypeSelected(value) {
    this.setState({
      listtype: value
    });
  }

  listTypeSelectedColumn(value, k) {
    let ColumnKeys = this.props.form.getFieldValue("ColumnKeys");
    let columns;
      if(Array.isArray(this.state.columns) && this.state.columns.length > 0) columns = [...this.state.columns] ;
      else if(Object.keys(this.props.preferencedata).length > 0 && this.props.preferencedata.Columns && this.props.preferencedata.Columns.length > 0) columns = [...this.props.preferencedata.Columns] ;
    let uuid = this.state.uuid;
    // let uuidLength = 0
    if (ColumnKeys.length != 0) {
      console.log("columnKeys before set 0 " + JSON.stringify(ColumnKeys));
      this.props.form.setFieldsValue({
        ColumnKeys: []
      });
      let ColumnKeys = this.props.form.getFieldValue("ColumnKeys");
      console.log("columnKeys after set 0 " + JSON.stringify(ColumnKeys));
      uuid = 0;
    }
    columns.splice(k, 1, value);
    const columnsFiltered = columns.filter(Boolean);

    //   let columnlist = columns
    //   ColumnKeys = this.props.form.getFieldValue("ColumnKeys");
    //    console.log("columnKeys equal to  0 outside function" +  JSON.stringify(ColumnKeys))
    //   if( ColumnKeys.length == 0 ){
    //     console.log("columnKeys equal to  0 " +  JSON.stringify(ColumnKeys))
    //     columnlist.filter(Boolean)
    //     columnlist.map((element, i) => {
    //       ColumnKeys = this.props.form.getFieldValue("ColumnKeys");
    //       if(element != undefined){
    //       let nextColumnKeys = ColumnKeys.concat(uuid++);

    //       // can use data-binding to set
    //       // important! notify form to detect changes
    //       console.log("nextColumnKeys " +  JSON.stringify(nextColumnKeys))
    //       this.props.form.setFieldsValue({
    //         ColumnKeys: nextColumnKeys
    //       });
    //     }
    //     })
    // }

    this.setState({
      columns: columnsFiltered,
      columnlist: columnsFiltered,
      savedpreferenceColumns: columnsFiltered,
      uuid: uuid
    });
    this.props.actions.changeUpdateColumnState("updating");

    //  this.showcolumnselection();
  }

  componentWillReceiveProps = nextprops => {
    // if (this.props.updatingColumns) {
    //   console.log("this.props.updatingColumns ");
    //   this.showcolumnselection();
    // }

    if (this.props.updatingColumns && !nextprops.updatingColumns) {
      console.log("next.updatingColumns ");
      // this.showcolumnselection();

      const { form } = this.props;
      const ColumnKeys = form.getFieldValue("ColumnKeys");
      if (ColumnKeys.length == 0) {
        let uuid = 0;
        console.log('this.state.savedpreferenceColumns', this.state.savedpreferenceColumns);
        console.log('this.state.columnlist', this.state.columnlist);
        let columnlist =
          this.state.savedpreferenceColumns.length == 0
            ? this.state.columnlist
            : this.state.savedpreferenceColumns.filter(Boolean);
        columnlist.filter(Boolean);
        columnlist.map(element => {
          const ColumnKeys = form.getFieldValue("ColumnKeys");
          const newKey = uuid++;
          const nextColumnKeys = ColumnKeys.concat(newKey);

          this.state.columnKeyValues[newKey] = typeof element === "string" ? element : "";

          form.setFieldsValue({
            ColumnKeys: nextColumnKeys
          });
        });
        this.setState({
          uuid: uuid
        });
      }
    }

    if (!this.props.updatingColumns && nextprops.updatingColumns) {
      this.props.actions.changeUpdateColumnState("updated");
    }

    if (this.props.preferencedata !== nextprops.preferencedata) {
      if (nextprops.preferencedata) {
        groupids = [];
        result = [];
        this.id = 0;
        this.ide = 0;
        this.ids = 0;
        uid = 0;

        this.props.form.setFieldsValue({
          keys: []
        });
        this.setState({
          columIdByChield: []
        });
        this.loadEditData(nextprops.preferencedata);

        //this.props.actions.RunPreference('advancedsearch',this.state.savedpreferenceType,nextprops.preferencedata.Columns)
        if (this.state.savedpreferenceColumns.length == 0) {
          let newPreferenceColumns = nextprops.preferencedata.Columns.slice(); // Copy the existing array

          // Check if "personguid" is not already in the array and add it
          if (!newPreferenceColumns.includes("personguid")) {
            newPreferenceColumns.push("personguid");
          }
          this.setState({
            savedpreferenceColumns: newPreferenceColumns
          });
        }
        if (this.state.preference.length == 0) {
          let newPreferenceColumns = nextprops.preferencedata.Columns.slice(); // Copy the existing array

          // Check if "personguid" is not already in the array and add it
          if (!newPreferenceColumns.includes("personguid")) {
            newPreferenceColumns.push("personguid");
          }
          this.setState({
            savedpreferenceColumns: newPreferenceColumns
          });
        }
      }
    }
  };

  componentDidMount = () => {
    this.props.actions.getStates();
    if (this.props.match.params.preferencename) {
      this.getcolumnlist(this.state.columns);
      selectedPreferenceName = this.props.match.params.preferencename;
      if (this.state.savedpreference == "")
        this.setState({
          savedpreference: selectedPreferenceName
        });
      SelectedListType = this.props.match.params.listtype;  
      let savedpreferenceType = this.state.savedpreferenceType;
      let listtype = this.state.listtype;
        this.setState({
          savedpreferenceType: SelectedListType ? SelectedListType : savedpreferenceType,
          listtype: SelectedListType ? SelectedListType : listtype 
        });
      if (this.props.match.params.mode) {
        let ViewModeValue = this.props.match.params.mode;
        let ViewMode = ViewModeValue == "v" ? true : false;
        if (this.state.ViewMode == "")
          this.setState({
            ViewMode: ViewMode
          });
      }
      this.props.actions.getlist(
        this.props.match.params.preferencename,
        this.props.match.params.listtype,
      );
    } else {
      this.add();
    }
  };
  onIdle = () => {
    this.props.actions.sessionTimeOut();
  };

  handleSearchRedirect = record => {
    // const isQuickAdminSearch =  window.location.pathname.includes('/list-and-search');

    // if (isQuickAdminSearch === true) {
    localStorage.setItem("prevPath", "list-and-search");
    this.props.history.push(
      "/alumni-profile/" + record.personguid + "/list-and-search"
    );
    // }
  };

  getcolumns = () => {
    const columnlistArray = this.props.getNewReportColumn || [];
  
    return columnlistArray
      .filter(({ name }) => name && !INTERNAL_ONLY_COLUMNS.includes(name.toLowerCase()) && !FILTER_ONLY_COLUMNS.includes(name.toLowerCase()) && name.toLowerCase() !== 'nationalawardid') //AAG-252 Oleg stated that we don't have such a "CouncilNumber" column. AAG-1400: PersonGUID is internal-only too, so keep it out of the "Change Column" options and the table columns. DoNotContact/AlumniPrivacy are table-only (FILTER_ONLY_COLUMNS).
      .map(({ name, caption }, index) => {
        const value = REPORT_COLUMN_ALIASES[name.toLowerCase()] || name.toLowerCase();
        return (
          <option key={index} value={value}>
            {caption}
          </option>
        );
      });
  };

  handelgetPersonGuid = PersonGuid => {
    this.props.getPersonGuid(PersonGuid);
  };

  returnUpdatedPreferenceList = () => {
    let preferenceList = Array.isArray(this.props.preferencelist) ? this.props.preferencelist : [];
    // let getNationalAwardsFilter = this.state.expressions.filter(exp => exp.ColumnName == 'nationalaward')
    // let getScoutingAffiliationFilter = this.state.expressions.filter(exp => exp.ColumnName == 'scoutingaffiliation')
    // let getCouncilAffiliationFilter = this.state.expressions.filter(exp => exp.ColumnName == 'councilaffiliation')
    // let getSocialMediaFilter = this.state.expressions.filter(exp => exp.ColumnName == 'socialmedia')
    
    const filters = this.state.filters || [];

    let getNationalAwardsFilter = filters.filter(f => f.includes('nationalaward'));
    let getScoutingAffiliationFilter = filters.filter(f => f.includes('scoutingaffiliation'));
    let getCouncilAffiliationFilter = filters.filter(f => f.includes('councilaffiliation'));
    let getSocialMediaFilter = filters.filter(f => f.includes('socialmedia'));

    let updatedPreferenceNameslist = preferenceList.map(item => {
      if (item.ethnicityid && Array.isArray(this.props.ethnicities)) {
        const match = this.props.ethnicities.find(eth => eth.id == item.ethnicityid);
        return { ...item, ethnicity: match ? match.name : '' };
      }

      if (getSocialMediaFilter.length > 0) {
        const socialmedia = item.socialmedia || '';
        const newValues = getSocialMediaFilter
          .map(filter => filter.Value.replace('name', ''))
          .filter(value => !socialmedia.includes(value))
          .join(', ');
      
        return { ...item, socialmedia: newValues ? `${socialmedia}${socialmedia ? ', ' : ''}${newValues}` : socialmedia };
      }
      // if (item.nationalaward) {
      //   return {
      //     ...item,
      //     nationalaward: getNationalAwardsFilter.map(award => {
      //       if(item.nationalaward.includes(award.Value)){
      //         return award.Value
      //       }
      //       else return null;
      //     }).filter(item => item !== null).join(', ')
      //   }
      // } else if (item.scoutingaffiliation) {
      //   return {
      //     ...item,
      //     scoutingaffiliation: getScoutingAffiliationFilter.map(award => {
      //       if(item.scoutingaffiliation.includes(award.Value)){
      //         return award.Value
      //       }
      //       else return null;
      //     }).filter(item => item !== null).join(', ')
      //   }
      // } else if (item.councilaffiliation) {
      //   return {
      //     ...item,
      //     councilaffiliation: getCouncilAffiliationFilter.map(award => {
      //       if(item.councilaffiliation.includes(award.Value)){
      //         return award.Value
      //       }
      //       else return null;
      //     }).filter(item => item !== null).join(', ')
      //   }
      // } 
      else return {
        ...item
      }
    });

    for (let i = 0; i < updatedPreferenceNameslist.length; i++) {
      if (updatedPreferenceNameslist[i].boardofreviewdt) {
        let convertedBoRdate = moment.utc(
          updatedPreferenceNameslist[i].boardofreviewdt
        ).format("YYYY-MM-DD");
        updatedPreferenceNameslist[i].boardofreviewdt = convertedBoRdate;
      }
    }

    return updatedPreferenceNameslist;
  };

  // getcolumnlist = columnname => {
  //   let Columnstate = columnname; // this.state.columns;
  //   let columnArr = Columnstate;
  //   let columnjsonArr = [];
  //   // columnArr.includes('personguid') ? "" : columnArr.push('personguid')
    
  //   // if(columnArr.includes('scoutingaffiliation')){ // issue reported on AAG-1070 -- 'Scouting Affiliation' filter is not displayed on Search Result columns -- So commented this removing functionality
  //   //   let removeScoutingAffiliationColumn = columnArr.filter(e => e != 'scoutingaffiliation')
  //   //   columnArr = removeScoutingAffiliationColumn;
  //   // }

  //   // if(columnArr.includes('socialmedia')){
  //   //   let removeScoutingAffiliationColumn = columnArr.filter(e => e != 'socialmedia')
  //   //   columnArr = removeScoutingAffiliationColumn;
  //   // }
    
  //   columnArr = columnArr.reduce((acc, item) => {
  //     if (item && !acc.includes(item)) { //Add column if its not exist (remove duplicate columns)
  //       acc.push(item);
  //     }
  //     return acc;
  //   }, []);
  

  //   columnArr.map(function(columnname ) {
  //     if (columnname == 'AlumniPrivacy' || columnname == 'councilnumber' ) { // to Hide the AlumniPrivacy column from the search results table
  //       return;
  //     } else {
  //       let columntitle = "";
  //       if (columnname == "nesa_addressline1") {
  //         columnname = "ship_to_addressline1";
  //       }
  //       if (columnname == "nesa_addressline2") {
  //         columnname = "ship_to_addressline1";
  //       }
  //       if (columnname == "nesa_addressline3") {
  //         columnname = "ship_to_addressline3";
  //       }
  //       if (columnname == "nesa_zip5") {
  //         columnname = "ship_to_zip5";
  //       }
  //       if (columnname == "nesa_zip4") {
  //         columnname = "ship_to_zip4";
  //       }
  //       if (columnname == "nesa_city") {
  //         columnname = "ship_to_city";
  //       }
  //       if (columnname == "nesa_state") {
  //         columnname = "ship_to_state";
  //       }
  
  //       columnjsonArr.push({
  //         title: columntitle === "" ? columnname : columntitle,
  //         dataIndex: columnname,
  //         key: columnname,
  //         render: (_, record) => {
  //           const value = record[columnname];
            
  //           if (
  //             value === "nationalaward" ||
  //             value === "scoutingaffiliation" ||
  //             value === "councilaffiliation"
  //           ) {
  //             return (
  //               <Tooltip title={value}>
  //                 <div style={{
  //                   whiteSpace: 'nowrap',
  //                   overflow: 'hidden',
  //                   textOverflow: 'ellipsis',
  //                   maxWidth: 150,
  //                 }}>
  //                   {value}
  //                 </div>
  //               </Tooltip>
  //             );
  //           } else {
  //             return value;
  //           }
  //         }
  //       });
  //     }
  //   });

  //   if (this.props.isadmin) {
  //     columnjsonArr.push({
  //       dataIndex: "Manage",
  //       key: "Manage",
  //       fixed: "right",
  //       width: 100,
  //       render: (text, record) => (
  //         <span className="editRow">
  //           {/* <a onClick={() => this.props.history.push('/list-and-search/' + record.personguid + '/list-and-search')} > <i className="fa fa-pencil margin-right-5"></i> Manage</a> */}
  //           <a onClick={() => this.handelgetPersonGuid(record.personguid)}>
  //             {" "}
  //             <i className="fa fa-pencil margin-right-5"></i> Manage
  //           </a>
  //         </span>
  //       )
  //     });
  //   }
  //   if (this.props.isspecialist) {
  //     columnjsonArr.push({
  //       dataIndex: "View",
  //       key: "View",
  //       fixed: "right",
  //       width: 100,
  //       render: (text, record) => (
  //         <span className="editRow">
  //           {/* <a onClick={() => this.props.history.push('/list-and-search/' + record.personguid + '/list-and-search')} > <i className="fa fa-pencil margin-right-5"></i> Manage</a> */}
  //           <a onClick={() => this.handleSearchRedirect(record)}>
  //             {" "}
  //             <i className="fa fa-eye margin-right-5"></i> View
  //           </a>
  //         </span>
  //       )
  //     });
  //   }
  //   // let newColumnjsonArr = columnjsonArr.filter((element) => element.key !== "personguid");
  //   this.setState({
  //     columnjson: columnjsonArr //newColumnjsonArr
  //   });
  // };
  getcolumnlist = (columnname = []) => { // enhaced getcolumnlist
    //Remove duplicates + invalid values
    let columnArr = [...new Set(columnname.filter(Boolean))];
  
    //Mapping for column transformations
    const columnMap = {
      // nesa_addressline1: "ship_to_addressline1",
      // nesa_addressline2: "ship_to_addressline2",
      // nesa_addressline3: "ship_to_addressline3",
      // nesa_zip5: "ship_to_zip5",
      // nesa_zip4: "ship_to_zip4",
      // nesa_city: "ship_to_city",
      // nesa_state: "ship_to_state",
      skpersonid: "memberid",
    };
  
    //Columns to ignore in the table result
    const hiddenColumns = INTERNAL_ONLY_COLUMNS;
  
    //Build column JSON
    let columnjsonArr = columnArr
      .filter(col => !hiddenColumns.includes(col))
      .map(col => {
        const mappedColumn = columnMap[col] || col;

        // Decided once per column (not per cell): boolean filter columns show TRUE/FALSE instead of 1/0.
        if (BooleanFilters.includes(mappedColumn.toLowerCase())) {
          return {
            title: mappedColumn,
            dataIndex: mappedColumn,
            key: mappedColumn,
            render: (_, record) => {
              const value = record[mappedColumn];
              if (value === null || value === undefined || value === "") return value;
              return value === 1 || value === "1" || value === true || String(value).toLowerCase() === "true" ? "TRUE" : "FALSE";
            }
          };
        }

        return {
          title: mappedColumn,
          dataIndex: mappedColumn,
          key: mappedColumn,
          render: (_, record) => {
            const value = record[mappedColumn];
  
            if (
              value === "nationalaward" ||
              value === "scoutingaffiliation" ||
              value === "councilaffiliation"
            ) {
              return (
                <Tooltip title={value}>
                  <div
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: 150
                    }}
                  >
                    {value}
                  </div>
                </Tooltip>
              );
            }
  
            return value;
          }
        };
      });
  
    if (this.props.isadmin) {
      columnjsonArr.push({
        dataIndex: "Manage",
        key: "Manage",
        fixed: "right",
        width: 100,
        render: (_, record) => (
          <span className="editRow">
            <a onClick={() => this.handelgetPersonGuid(record.personguid)}>
              <i className="fa fa-pencil margin-right-5"></i> Manage
            </a>
          </span>
        )
      });
    }
  
    if (this.props.isspecialist) {
      columnjsonArr.push({
        dataIndex: "View",
        key: "View",
        fixed: "right",
        width: 100,
        render: (_, record) => (
          <span className="editRow">
            <a onClick={() => this.handleSearchRedirect(record)}>
              <i className="fa fa-eye margin-right-5"></i> View
            </a>
          </span>
        )
      });
    }
  
    this.setState({
      columnjson: columnjsonArr
    });
  };

  downloadCSV = () => {
    const { fileName } = this.state
    console.log('Download:', fileName)

    this.props.actions.downloadAdvanceSearchResultsAsCSV(fileName);
  };

  savelist = (listname) => {
    let regExp = RegExp(/^[a-zA-Z0-9\s\-,_()]+$/);

    if (!regExp.test(listname)) {
      message.error("Invalid characters in list name! Only letters, numbers, spaces, commas, hyphens, underscores, and parentheses are allowed.");
    } else {
      let listtype = this.state.listtype
      let filters = this.state.filters
      if (this.state.preference && Array.isArray(this.state.preference.Expressions) && this.state.preference.Expressions.length > 0) {
        filters = this.state.preference;
      }
      let columnList = this.state.columnlist
      if (Array.isArray(columnList.DisplayColumnLists) && columnList.DisplayColumnLists.length > 0) {
        columnList = columnList.DisplayColumnLists.map(item => {
          if (typeof item === "object") {
            // If item is an object, extract the first key-value pair's value
            return Object.entries(item)[0][1];
          } else {
            // If it's not an object, just return the item itself
            return item;
          }
        })
      }
      filters.Expressions = this.modifyExpiression(filters.Expressions);

      const refinedColumns = this.removeDuplicateColumns(columnList);
      
      this.props.actions.savelist(filters, listname, listtype, refinedColumns, true, this.state.perPageSize, this.state.currentpage, this.props.maxRecords, null, this.state.isEaglesOnly)
    }
  }

  addColumn = (columnName) => {
    const { form } = this.props;
    // can use data-binding to get
    const ColumnKeys = form.getFieldValue("ColumnKeys");
    const newKey = this.state.uuid++;
    const nextColumnKeys = ColumnKeys.concat(newKey);

    // Remember which column this new row represents by its own stable key
    // (not by array position - see the initialValue lookup above) (AAG-1400).
    this.state.columnKeyValues[newKey] = typeof columnName === "string" ? columnName : "";

    // can use data-binding to set
    // important! notify form to detect changes
    form.setFieldsValue({
      ColumnKeys: nextColumnKeys
    });
  };

  showcolumnselection = () => {
    const { form } = this.props;
    const ColumnKeys = form.getFieldValue("ColumnKeys");
    if (ColumnKeys.length == 0) {
      let columnlist =
        this.state.savedpreferenceColumns.length == 0
          ? this.state.columnlist
          : this.state.savedpreferenceColumns;

      columnlist = columnlist.filter(
        col => col && !INTERNAL_ONLY_COLUMNS.includes(col.toLowerCase())
      );

      this.setState({
        columns: columnlist,
        columnlist: columnlist,
        savedpreferenceColumns: columnlist,
        columnDragOrder: null
      });

      columnlist.map(element => this.addColumn(element));
    }
    this.setState({
      changecolumnvisible: true
    });
    if (this.props.updatingColumns) {
      this.props.actions.changeUpdateColumnState("updated");
    }
  };

  closecolumnselection = () => {
    this.props.form.setFieldsValue({
      ColumnKeys: []
    });
    this.setState({
      changecolumnvisible: false,
      columnDragOrder: null
    });
  };

  renderpreferencelist = () => {
    const { advancedRecordsLoading, recordsLoading, advancedSearchLoading, alumnirecordsroot, preferencelist } = this.props;
  
    if (advancedRecordsLoading) {
      return (
          <div>
              <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Records..." />
          </div>
      );
    }

    if (alumnirecordsroot && alumnirecordsroot.RecordCount == 0) {
      return (
          <div>
              <p className="suspend-msg">No Records Found!</p>
          </div>
      );
    }
    
    if (preferencelist) {
      if (this.props.TotalRecordCount) {
        getTotalRecordCount = this.props.TotalRecordCount;
      }
      else if (this.props.alumnirecordsroot && this.props.alumnirecordsroot.RecordCount) {
         getTotalRecordCount = this.props.alumnirecordsroot.RecordCount;
      } else {
         getTotalRecordCount = 0;
      }
      if (!this.state.showSave) {
        this.setState({
          showSave: true
        });
      }

      const popoverContent = (
        <div
          style={{
            width: 420,
            maxWidth: 420
          }}
        >
          {Number(getTotalRecordCount) > 5000 && (
            <div
              style={{
                marginBottom: 12,
                color: '#faad14',
                fontSize: 12,
                lineHeight: '18px',
                wordBreak: 'break-word'
              }}
            >
              Your search matched more than 5,000 records. Only the first
              5,000 records will be included in the export. Please refine
              your search criteria if you need a smaller or more specific
              result set.
            </div>
          )}

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              width: '100%',
              boxSizing: 'border-box'
            }}
          >
            <Input
              placeholder="Enter file name"
              value={this.state.fileName}
              onChange={this.handleFileNameChange}
              style={{
                flex: 1,
                minWidth: 0
              }}
            />

            <Button
              type="primary"
              disabled={this.state.fileName.length == 0}
              icon={this.props.CSV_Downloading ? 'loading' : 'download'}
              loading={this.props.CSV_Downloading}
              onClick={this.downloadCSV}
              style={{
                flexShrink: 0
              }}
            >
              {this.props.CSV_Downloading
                ? 'Downloading CSV'
                : 'Download CSV'}
            </Button>
          </div>
        </div>
      )

      return (
        <div>
          <div className="tab-container">
            <Row
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <Col
                span={8}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: " space-around",
                }}
              >
                <Popover
                  content={popoverContent}
                  trigger="click"
                  placement="bottom"
                >
                  <label className="downloadBtn pointer">
                    <i className="fa fa-file-excel-o margin-right-5"></i>
                    Download
                  </label>
                </Popover>
                
                <ReactToPrint
                  trigger={() => (
                    <label class="printLabel">
                      <i className="fa fa-print margin-right-5"></i> Print
                    </label>
                  )}
                  content={() => this.componentRef}
                />
                <label //AAG-1264 show when the custom columns API is ready
                  className="margin-right-5 pointer"
                  onClick={this.showcolumnselection}
                >
                  <i className="fa fa-columns margin-right-5"></i> Change
                  Columns
                </label>
              </Col>
              <Col
                span={16}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  paddingRight: "20px"
                }}
              >
                <span className="records-count">
                  Total Contacts:{" "}
                  <b>
                    {getTotalRecordCount}
                  </b>
                </span>
                <Pagination
                  style={{ marginLeft: "10px" }}
                  current={this.state.currentpage}          
                  pageSize={this.state.perPageSize}   
                  pageSizeOptions={["10", "20", "30", "40", "100"]}
                  showSizeChanger
                  onShowSizeChange={this.onShowSizeChange}
                  total={getTotalRecordCount}
                  showTotal={(total, range) =>
                    `${range[0]}-${range[1]} of ${total} search results`
                  }
                  size="small"
                  onChange={this.onChange}
                  itemRender={this.paginationItemRender}
                />
              </Col>
              
            </Row>
          </div>

          <Table
            className="list_and_search_table"
            ref={el => (this.componentRef = el)}
            dataSource={this.returnUpdatedPreferenceList()}
            columns={this.state.columnjson}
            scroll={{ x: true }}
            pagination={false}
          />

          <div className="tab-container" style={{ borderRadius: '0px' , backgroundColor: '#f2f2f2' }}>
            <Row
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <Col
                span={24}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  paddingRight: "20px"
                }}
              >
                <span className="records-count">
                  Total Contacts:{" "}
                  <b>
                    {/* {this.props.alumnirecordsroot
                      ? this.props.alumnirecordsroot.RecordCount
                      : 0} */}
                      {getTotalRecordCount}
                  </b>
                </span>
                <Pagination
                  style={{ marginLeft: "10px" }}
                  current={this.state.currentpage}          
                  pageSize={this.state.perPageSize}    
                  defaultPageSize={this.state.perPageSize}
                  pageSizeOptions={["10", "20", "30", "40", "100"]}
                  showSizeChanger
                  onShowSizeChange={this.onShowSizeChange}
                  total={getTotalRecordCount}
                  showTotal={(total, range) =>
                    `${range[0]}-${range[1]} of ${total} search results`
                  }
                  size="small"
                  onChange={this.onChange}
                  itemRender={this.paginationItemRender}
                />
              </Col>
              </Row>
              </div>

         
        </div>
      );
    }
    return null;
  };

  componentWillMount() {
    console.log("worrking");
  }

  componentWillUnmount() {
    // this.props.onRef(undefined)
    groupids = [];
    result = [];
    this.id = 0;
    this.ide = 0;
    this.ids = 0;
    uid = 0;
    this.props.actions.removeAdvanceSearchResult();
  }

  reloadPage = () => {
    window.location.reload();
  };

  updateFieldsValue(data) {
    this.setState({
      updateFields: { ...this.state.updateFields, ...data }
    });
  }

  updatefieldsgroup(data) {
    this.setState({
      fieldsgroup: { ...this.state.fieldsgroup, ...data }
    });
  }
  upadtefieldsId(nextKeys) {
    this.setState({
      fieldsId: nextKeys.map(data => `fieldsId:` + data)
    });
  }
  updateColumIdByChield(data) {
    this.setState({
      columIdByChield: data
    });
  }

  checkCouncilNumberSelected(isSelected) { // True or False
    this.setState({
      isCouncilNumberSelected: isSelected 
    });
  }

  loadEditData = datas => {
    if (datas) {
      let y = datas.Filters.Formula.split("(")
        .toString()
        .split(")")
        .toString()
        .split(",");

      let filtered = y.filter(function(el) {
        return el.trim() != "" && el.trim() != null;
      });

      var id = 0;
      var ide = 0;
      var ids = 0;

      for (let i = 0; i < filtered.length; i += 2) {
        let fields = filtered[i].split(" ");

        var fieldsIds = [];
        for (let x = 0; x < fields.length; x++) {
          if (fields[x].includes("@exp")) {
            fieldsIds.push(ids++);
          }
        }
        groupids.push(`groupId:${id++}`);
        let newresults = (result[`groupId:${ide++}`] = fieldsIds);
        this.setState({
          results: newresults
        });
      }

      console.log(groupids);
      console.log(result);
      
      // let query = '(';
      let query = datas.Filters.Formula;
      let formula  = datas.Filters.Formula;
      datas.Filters.Expressions.forEach((data, expresKey) => {
        if (
          datas.Filters.Expressions[expresKey]["ColumnName"].includes("date") ||
          datas.Filters.Expressions[expresKey]["ColumnName"].includes("dt") ||
          datas.Filters.Expressions[expresKey]["ColumnName"].includes("Date")
        ) {
          let updatedData = data.Value.slice(0, -6);
          let formateddate = moment(updatedData).format("MM/DD/YYYY");
          data.Value = formateddate;
        }
        // query += ` ${data["ColumnName"]}  ${data["Operator"]} ${data["Value"]} ${extractedOperators[expresKey]} `
        query = query.replace( `@exp${expresKey}` ,`${data["ColumnName"]}  ${data["Operator"]} ${data["Value"]}`)
      });

      var fieldsValues = {};
      var index = 0;
      var ColumnName = [];
      var columnArr = [];
      var fieldsdata = filtered.map(data =>
        data.replace("AND NOT", "ANDNOT").replace("OR NOT", "ORNOT")
      );
      this.getcolumnlist(datas.Columns)
      fieldsdata.forEach(function(element, i) {
        var elarray = element.trim().split(" ");
        // console.log(elarray);
        elarray.forEach(function(dt, x) {
          var a = datas.Filters.Expressions.filter(function(el) {
            return el.ExpressionName == dt.replace("@", "");
          });
          var expr = a[0];
          if (expr) {
            var key = dt.replace("@exp", "");
            if (key) {
              index = key;
            }
            // if (expr.ColumnName) {
              
            //   ColumnName.push(expr.ColumnName);
            //   columnArr.push({
            //     title: ColumnName ? ColumnName : '',
            //     dataIndex: ColumnName,
            //     key: ColumnName
            //   });
            // }
            fieldsValues[key.toString() + "2"] = expr.ColumnName;
            fieldsValues[key.toString() + "3"] = expr.Operator;
            fieldsValues[key.toString() + "4"] = expr.Value;
          } else {
            if (dt == "ORNOT") {
              dt = "OR NOT";
            } else if (dt == "ANDNOT") {
              dt = "AND NOT";
            }
            fieldsValues[(parseInt(index) + 1).toString() + "1"] = dt;
          }
          // console.log("x1",x,dt,index);
        });
      });

      console.log(fieldsValues);

      if (groupids) {
        groupids.forEach((data, i) =>  this.add() );
        this.setState({
          filters: {Expressions: datas.Filters.Expressions, Formula: formula},
          updateFields: fieldsValues,
          expressions: datas.Filters.Expressions,
          query,
          formula,
          // columnjson: columnArr\
        });
      }
    }
  };


  changeName = e => {
      this.setState({
        savedpreference: e.target.value
      }); 
  };

  render() {
    const {
      getFieldDecorator,
      getFieldValue,
      setFieldsValue
    } = this.props.form;
    getFieldDecorator("ColumnKeys", { initialValue: [] });
    const ColumnKeys = getFieldValue("ColumnKeys");
    getFieldDecorator("keys", { initialValue: [] });
    const keys = getFieldValue("keys");
    console.log(this.state.results);
    let self = this;

    const orderedColumnKeys = this.getColumnKeyOrder(ColumnKeys);
    console.log("AAG1400_RENDER: ColumnKeys", JSON.stringify(ColumnKeys), "state.columnDragOrder", JSON.stringify(this.state.columnDragOrder), "orderedColumnKeys", JSON.stringify(orderedColumnKeys));
    const columnitems = [...new Set(orderedColumnKeys)].map((columnKey, index) => {
      console.log("*****Column Key before render", columnKey);
      console.log("*****Column index before render", index);
    
      return (
        <Draggable key={columnKey} draggableId={`draggable-${columnKey}`} index={index}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
            >
              <Row type="flex" justify="center" align="middle">
                <Col span={1}>
                  <i
                    {...provided.dragHandleProps}
                    className="drag-handler pointer fa fa-lg fa-ellipsis-v"
                  ></i>
                </Col>
                <Col span={18}>
                  <FormItem required={false}>
                    {getFieldDecorator(`columns[${columnKey}]`, {
                      // Look up this row's value by its own stable columnKey,
                      // not by array position - a position-based lookup goes
                      // stale as soon as rows are reordered (or a field
                      // remounts), since self.state.columns never itself
                      // reorders until Submit (AAG-1400).
                      initialValue: self.state.columnKeyValues[columnKey] || "",
                      validateTrigger: ["onChange", "onBlur"],
                      rules: [
                        {
                          required: true,
                          whitespace: true,
                        },
                      ],
                    })(
                      <Select
                        showSearch
                        placeholder="Select Column"
                        optionFilterProp="children"
                        onSelect={(value) => this.listTypeSelectedColumn(value, columnKey)}
                        className="folder-list"
                      >
                        {this.getcolumns()}
                      </Select>
                    )}
                  </FormItem>
                </Col>
                <Col span={2}>
                  <FormItem>
                    <Icon
                      className={
                        orderedColumnKeys.length === 1
                          ? "cancel-icon cancel-icon-disabled"
                          : "cancel-icon pointer"
                      }
                      onClick={() => {
                        if (orderedColumnKeys.length === 1) return;
                        this.removeColumn(index);
                      }}
                      type="close"
                    />
                  </FormItem>
                </Col>
              </Row>
            </div>
          )}
        </Draggable>
      );
    });
    
    const formItems = keys.map((k, index) => (
      <Draggable draggableId={this.state.columnId[index]} index={index}>
        {provided => (
          <div ref={provided.innerRef} {...provided.draggableProps}>
            <Row type="flex" justify="center" align="middle">
              {index >= 1 ? (
                <div className="left-drag-icon" style={{ zIndex: "99" }}>
                  <i
                    className="fa fa-arrows-alt"
                    {...provided.dragHandleProps}
                  ></i>
                </div>
              ) : (
                <div {...provided.dragHandleProps}></div>
              )}
              <Col span={23}>
                <GroupFields
                  onRef={ref => (this.child = ref)}
                  k={k}
                  index={index}
                  columnId={this.state.columnId}
                  updateFieldsValue={this.updateFieldsValue.bind(this)}
                  fieldsItems={this.state.fieldsItems}
                  updatefieldsgroup={this.updatefieldsgroup.bind(this)}
                  fieldsgroup={this.state.fieldsgroup}
                  upadtefieldsId={this.upadtefieldsId.bind(this)}
                  fieldsId={this.state.fieldsId}
                  updateColumIdByChield={this.updateColumIdByChield.bind(this)}
                  columIdByChield={this.state.columIdByChield}
                  fieldiddata={this.state.updateFields}
                  getFieldDecorator={getFieldDecorator}
                  getFieldValue={getFieldValue}
                  setFieldsValue={setFieldsValue}
                  groupids={groupids}
                  result={result}
                  newresult={this.state.results}
                  checkCouncilNumberSelectedHandler={(value) => this.checkCouncilNumberSelected(value)}
                />

                {console.log(k, index, this.state.columnId)}
                {console.log(groupids)}
              </Col>
              <Col span={1}>
                <div className="remove-group-icon">
                  {keys.length != 1 ? (
                    <Tooltip placement="top" title="Remove this Group Filter">
                      {index >= 1 ? (
                        <Icon
                          onClick={() => this.remove(k)}
                          type="close-circle"
                          disabled={index === 1}
                        />
                      ) : (
                        ""
                      )}
                    </Tooltip>
                  ) : null}
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Draggable>
    ));

    return (
      <div>
        <Form id="AdvancedSearchForm" onSubmit={this.handleSubmit}>
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="droppable" type="column">
              {provided => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {formItems}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          
          <Row style={{ display: 'flex', justifyContent: 'flex-start', alignItems:'center' }}>
            {/* AAG-1264 */}
            {/* <Col span={6}> //AAG-1264
              {!this.state.ViewMode && (
                <div className="margin-bottom-20 add-group">
                  <hr className="group-line-vertical" />
                  <span className="pointer" onClick={this.add}>
                    {" "}
                    <Icon type="plus-circle" theme="filled" /> Add Group{" "}
                  </span>
                </div>
              )}
            </Col> */}
            <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: '70px' }}>
              {this.state.isCouncilNumberSelected && <FormItem  style={{margin: 'unset'}}>
                <div className="margin-bottom-20 add-group">
                  <hr className="group-line-vertical" />
                  <Checkbox className="updateorganization-checkbo pointer" checked={this.state.isEaglesOnly} //1264 need isEaglesOnly filter in API
                  onChange={(e) => this.setState({ isEaglesOnly: e.target.checked })} style={{fontWeight: 'bold', color: '#1890ff'}}> Eagles Only </Checkbox>
                </div>
              </FormItem>}
            </Col>
          </Row>
          

          <div className="query-footer">
            {/* {this.state.expressions.length > 0 && <div>
              <span className="query">List Formula</span>
              <p dangerouslySetInnerHTML={{ __html: this.state.query }} />
              <p dangerouslySetInnerHTML={{ __html: this.state.formula }} />
              <p>
                {this.state.expressions.map((item, i) => (
                  <li key={i}>
                    "ExpressionName":{item.ExpressionName}
                    "ColumnName":{item.ColumnName}
                    "Operator":{item.Operator}
                    {`${!["NULL", "NOTNULL", "NE"].includes(item.Operator) ? `"Value":${item.Value}` : ''}`}
                  </li>
                ))}
              </p>
            </div>
            } */}
            {/* <div className="community-org-div">
              <CommunityTypes />
            </div> */}
            <Row type="flex" justify="space-between" align="middle">
              <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                <FormItem>
                  <Button type="width-100 cancel-btn" onClick={this.reloadPage}>
                    {" "}
                    Cancel{" "}
                  </Button>
                </FormItem>
              </Col>
              {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}> */}

                {/* <Col xs={24} sm={24} md={10} lg={10} xl={10} style={{display: 'flex', justifyContent='end' }}>
                <FormItem>
                            
                  <Checkbox className="updateorganization-checkbox" checked={this.state.isEaglesOnly} onChange={ (e) => this.setState({isEaglesOnly: e.target.checked})}> Eagles Only </Checkbox>

                  </FormItem>
                </Col> */}
                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                  <FormItem>
                    <Button
                      ref={button => {
                        this.SubmitButton = button;
                      }}
                      type="primary width-100 submit-btn"
                      className="advanced-search-submit-btn"
                      htmlType="submit"
                      loading={this.props.advancedRecordsLoading}
                    >
                      {this.props.advancedRecordsLoading ? 'Searching...' : 'Show List Results'}
                    </Button>
                  </FormItem>
                </Col>
              {/* </Col> */}
            </Row>

            {/* {this.state.showSave && ( //AAG-1264 hidden for now => Save filter
              <div className="save-list-container">
                <div className="save-panel">
                  <label>Save List as…</label>
                  <Select
                    disabled={this.state.ViewMode}
                    showSearch
                    defaultValue={this.state.savedpreferenceType}
                    placeholder="Select Column"
                    optionFilterProp="children"
                    onChange={this.listTypeSelected}
                    className="folder-list"
                  >
                    <Option value="1">My List </Option>
                    <Option value="2">Public List </Option>
                    <Option value="3">Quick List </Option>
                  </Select>
                  <Save
                    disabled={this.state.ViewMode}
                    placeholder="Type List Name"
                    enterButton="Save"
                    onChange={this.changeName}
                    value={this.state.savedpreference}
                    onSearch={listname => this.savelist(listname)}
                  />
                </div>
              </div>
            )} */}
          </div>
        </Form>
        {this.renderpreferencelist()}

        <Modal
          title="Change Columns"
          centered
          className="column-list-selection"
          visible={this.state.changecolumnvisible}
          footer={[]}
        >
          <Form onSubmit={this.handleColumnSubmit}>
            {this.props.updatingColumns ? (
              <Spin
                indicator={LoadingIcon}
                className="loading-state"
                // tip="updating columns..."
              />
            ) : (
              <div>
                <DragDropContext
                  key={orderedColumnKeys.join(",")}
                  onDragEnd={this.onColumnDragEnd}
                >
                  <Droppable droppableId="columns-droppable">
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                      >
                        {columnitems}

                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

                <Row type="flex" justify="flex-end" align="middle">
                  <Col span={21}>
                    <div className="add-column-panel">
                      <span
                        className="pointer"
                        onClick={() => this.addColumn([""])}
                      >
                        <Icon type="plus-circle-o" /> Add Column
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
            <Row type="flex" justify="space-around">
              <Col xs={24} sm={24} md={8} lg={8}>
                <Button
                  className="cancelbtn"
                  disabled={this.props.updatingColumns}
                  onClick={() => this.closecolumnselection(false)}
                >
                  {" "}
                  Cancel{" "}
                </Button>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8}>
                <FormItem>
                  <Button
                    className="submitbtn"
                    htmlType="submit"
                    disabled={this.props.updatingColumns}
                  >
                    {" "}
                    Submit{" "}
                  </Button>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    alumnirecordsroot: state.quicksearchrootreducer.alumnirecordsroot,
    error: state.columnlistreducer.error,
    columnlist: state.columnlistreducer.columnlist,
    advancedSearchLoading: state.advancedsearchreducer.loading,
    allstates: state.allstatesreducer.states,
    preferencelist: state.advancedsearchreducer.preferencelist,
    maxRecords: state.advancedsearchreducer.maxRecords,
    TotalRecordCount: state.advancedsearchreducer.TotalRecordCount,
    preferencedata: state.getpreferencedatareducer.preferencedata,
    // maxRecords: state.getpreferencedatareducer.maxRecords,
    isadmin: state.isadminreducer.isadmin,
    isspecialist: state.isadminreducer.isspecialist,
    updatingColumns: state.changeColumnStateReducer.updatingColumns,
    ethnicities_loading: state.ethnicitiesreducer.loading,
    ethnicities: state.ethnicitiesreducer.ethnicities,
    isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
    // recordsLoading: state.recordsLoaderReducer.loading,
    advancedRecordsLoading: state.advancedRecordsLoaderReducer.loading,

    getNewReportColumnLoading: state.getNewReportColumnReducer.loading,
    getNewReportColumn: state.getNewReportColumnReducer.getColumn,
    getNewReportColumnFailed: state.getNewReportColumnReducer.error,

    CSV_Downloading: state.downloadAdvSearchResultsCSV.loading,
    councils: state.councilsreducer.councils,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

const QueryBuilder = Form.create()(DynamicFieldSet);

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(QueryBuilder);


// WEBPACK FOOTER //
// ./src/components/ListandAdvancedSearch/QueryBuilder.js